import { plainToInstance } from 'class-transformer'

import { PropertyFieldType } from '../../../../../../../../../BotProperties/components/Properties/types'
import {
  PropertyValue,
  PropValueCalculate,
  PropValueConstant,
  PropValueNow,
  PropValueProperty,
} from './PropertyActionValue'
import { SetPropertyActionValue } from './types'

export const GetPropertyActionValueSample = (type: SetPropertyActionValue, currentPropType: PropertyFieldType): PropertyValue => {
    switch (type) {
      case SetPropertyActionValue.Property:
        return plainToInstance(PropValueProperty, {
          type: SetPropertyActionValue.Property,
          property_index: null,
          transform: null
        })
      case SetPropertyActionValue.Calculate:
        return plainToInstance(PropValueCalculate, {
          type,
          value: ''
        })
      case SetPropertyActionValue.Constant:
        return plainToInstance(PropValueConstant, {
          type,
          value: [ PropertyFieldType.Number, PropertyFieldType.Double ].includes(currentPropType) ? 0 : ''
        })
      default:
        return plainToInstance(PropValueNow, { type })
    }
}
